import {AfterContentChecked, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'particle-document-repository-cell-viewer',
  templateUrl: './document-repository-cell-viewer.component.html',
  styleUrls: ['./document-repository-cell-viewer.component.scss']
})

export class DocumentRepositoryCellViewerComponent implements OnInit, AfterContentChecked, CellComponent {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;

  constructor(private router: Router) {
  }

  ngOnInit() {
    console.log('[DocumentRepositoryCellViewerComponent]', this.item);
    this.disabled = !this.item.isReadOnly;
  }

  setIcon() {
    if (this.item.cells.IsFolder) {
      if (this.item.cells.IsFolder.value) {
        this.icon = 'far fa-folder';
      } else {
        this.icon = 'far fa-file-invoice';
      }
    } else {
      switch (this.item.cells.Type.value) {
        case 'SharedDrives':
          this.icon = 'far fa-layer-group';
          break;
        case 'SharedDrive':
          this.icon = 'far fa-hdd';
          break;
        case 'PersonalDrive':
          this.icon = 'far fa-hdd';
          break;
        case 'SharedWithMe':
          this.icon = 'far fa-hdd';
          break;
        case 'Folder':
          this.icon = 'far fa-folder';
          break;
        case 'Document':
          this.icon = 'far fa-file-invoice';
          break;
      }
    }
  }

  onClickDocumentRepository(event$) {
    this.valueChanged.emit(event$);
  }

  ngAfterContentChecked(): void {
    this.setIcon();
  }
}
